import styled from "styled-components";
import {JackpotBetWinHighlightAmountDefaultBox} from "./jackpot-bet-win-highlight-amount.default.box";


export const JackpotBetWinHighlightAmountMRGreenBox = styled(JackpotBetWinHighlightAmountDefaultBox)`
    color: #FFED40;
    linear-gradient(90deg, #F1C141 0%, #F9F19A 48.96%, #F1C141 100%);
`;
